import { BUSINESS_BOOKING_API_URL, API_BASE_URL } from '../library/globals';
import { GET } from './api-hander.service';
import { FETCH_PRINT_HISTORY, GET_BULK_LABEL_REQUEST } from './api.constants';

export const getPrintHistory = async (body = {}) => {
    return GET(`${BUSINESS_BOOKING_API_URL}${FETCH_PRINT_HISTORY}`, { ...body });
};

export const getBulkLabelRequestPx = async (body: any) => {
    const response = await GET(`${API_BASE_URL}${GET_BULK_LABEL_REQUEST}`, body);
    return response;
};
